export default __webpack_public_path__ + "static/media/collapsed.b9a7215a.svg";